import type { ClientAccessDenial, ClientAccessDeniedBody } from "@repo/shared/types";
import { ApiError } from "./_client";

/** QL-380 — the denial in a 403 response body, else null. */
export function clientAccessDenialFromBody(body: unknown): ClientAccessDenial | null {
  const b = body as Partial<ClientAccessDeniedBody> | null | undefined;
  return b?.code === "client_access_denied" && b.denial ? b.denial : null;
}

/** QL-380 — the denial behind a 403 on a client (or anything under it), else null. */
export function clientAccessDenialOf(error: unknown): ClientAccessDenial | null {
  if (!(error instanceof ApiError) || error.status !== 403) return null;
  return clientAccessDenialFromBody(error.body);
}
